import { render, staticRenderFns } from "./Manufacturings.vue?vue&type=template&id=52117d68&lang=pug&"
import script from "./Manufacturings.vue?vue&type=script&lang=js&"
export * from "./Manufacturings.vue?vue&type=script&lang=js&"
import style0 from "./Manufacturings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports